/**
 * Return an array of two arrays, the first containing the elements for which the predicate returned true, the second containing the elements for which the predicate returned false.
 * @function partition
 * @param {T[]} array
 * @param {(value: T, index: number, array: T[]) => boolean} filter
 * @returns {[T[],T[]]} tuple of elements for which the predicate returned true, the second containing the elements for which the predicate returned false.
 */
export const partition = <T>(
	array: T[],
	filter: (value: T, index: number, array: T[]) => boolean
): [T[], T[]] => {
	const pass: T[] = [],
		fail: T[] = [];

	for (let i = 0, l = array.length; i < l; i++) {
		// Safe assertion; loop will only run for a valid element
		const elem = array[i]!;

		(filter(elem, i, array) ? pass : fail).push(elem);
	}

	return [pass, fail];
};
